import { ooFetchWithResponse } from './ooFetchWithResponse';

let transactionsApi = {
    createSingle: async (params) => {
        let url = 'transactions/v1';
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
    getCategories: async () => {
        let url = 'transactions/v1/categories';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getItemDetails: async (startDate, endDate) => {
        let url = 'transactions/v1?startDate=' + startDate + '&endDate=' + endDate;
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getMergedCategories: async () => {
        let url = 'transactions/v1/mergedCategories';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getSubCategories: async (category) => {
        let url = 'transactions/v1/subCategories?category=' + category;
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    updateTransaction: async (id, params) => {
        let url = 'transactions/v1/' + id;
        let body = JSON.stringify(params);
        let response = await ooFetchWithResponse(url, { method: "PUT", body: body });
        return response;
    }
}

export { transactionsApi };